<template>
    <div :class='TextClasses'>  
        <!-- <label :for='id' v-if="(getLabel)">{{ formattedLabel }}</label>  -->
        <component :is="component" :type='type.type' :name="name.input" :value='value.value' :label="label.input" v-if="component" v-bind='componentProps' />
    </div>
</template>

<script>
    export default {
        name: 'DisplayFormInput',
        props: ['callback', 'field', 'firstSpan', 'columns', 'disabled', 'name', 'input', 'type', 'iconSide', 'options', 'multiple', 'size', 'label', 'value', 'identifier', 'store', 'validationRules', 'disabled', 'hasErrors'],
        data() {
            return {
                component: null,
                getLabel: this.$props.label,
                phvalue: this.$props.value == '' ? 'Form Input' : this.$props.value,
                isDisabled: this.$props.disabled,
                id: this.$props.identifier,
                inputName: this.$props.name,
                inputFunction: this.$props.callback,
                mainClass:this.$props.type
            }
        },
        computed: {
            loader() {
                if (!this.type) {
                    return null
                }
                return () => import(`./${this.type}`)
            },
            formattedLabel(){
                return  this.getLabel.replace('__c', '').replaceAll('_', ' ')
            },
            TextClasses(){
                return [
                    this.mainClass,{
                    TopSpan: this.$props.firstSpan,
                    'col-3': this.$props.columns == 4,
                    'col-4': this.$props.columns == 3,
                    'col-6': this.$props.columns == 2,
                    'col-12': this.$props.columns == 1
                    }
                ]
            },
            componentProps(){
                return this.$props
            }
        },

        watch:{
            componentProps(newComponentProps, oldComponentProps){
                console.log('changed - ' + Object.entries(newComponentProps))
                this.uaidx += 1
            }
        },
        mounted() {
            this.loader()
                .then(() => {
                    this.component = () => this.loader()
                })
                .catch(() => {
                    this.component = () => import('./TextBox')
                })
        }
    }
</script>